// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PurchasesQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query-string input for GET /ai/credits/purchases.
 *
 * Optional:
 *   limit (int|null) — max rows; server default/cap applies when absent or out of range
 */
import { registerContract } from './validate'

export interface AiCredits_PurchasesQueryInput {
limit?: number
}

registerContract('AiCredits_PurchasesQueryInput', {
  limit: { type: 'number',  required: false },
})
